import React from 'react';

import styles from './OffersLayout3.module.scss';

import OfferTimer from "../../OfferTimer/OfferTimer";
import {FREE_TEXT, TAX_INCLUDED_TEXT} from "../../../../shared/constants";
import LoadableImage from "../../../LoadableImage/LoadableImage";

const OffersLayout3 = ({
    packId,
    image,
    priceFormatted,
    popUpImg,
    selectOfferById,
    openPopupInfo,
    endTime,
    categoryId,
    noTimers,
    isFree,
    isClaimed,
    noQuantityCap,
    leftPurchases
}) => {
    const id = packId;

    return (
        <div>
            {noTimers ?
                null
                :
                endTime ?
                    <OfferTimer endTime={endTime} isFree={isFree} />
                    :
                    <div className={styles.endsIn}></div>
            }
            {noQuantityCap ?
                null
                :
                <div className={`${styles.quantityCap} ${!noQuantityCap ? styles.hasQuatityCap : ''}`}>
                    {leftPurchases ?
                        `残り回数：${leftPurchases}`
                        :
                        null
                    }
                </div>
            }
            <div className={`${styles.wrapper} ${isClaimed ? styles.claimed : null}`}>
                <LoadableImage img={image} />
                <div className={styles.offerLayoutPrice} onClick={() => selectOfferById(id, categoryId)}>
                    <div className={styles.offerPrice}>{!isFree ? priceFormatted : FREE_TEXT}</div>
                    {!isFree ? <div className={styles.offerPriceText}>{TAX_INCLUDED_TEXT}</div> : null}
                </div>
                {popUpImg && openPopupInfo ?
                    <div
                        className={styles.buttonInfo}
                        onClick={() => openPopupInfo({
                            img: popUpImg,
                            id: id,
                            categoryId: categoryId,
                            price: priceFormatted,
                            isFree: isFree
                        })}
                    ></div>
                    :
                    null
                }
            </div>
        </div>
    );
};

export default OffersLayout3;